import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SITE_ORIGIN_TOKEN } from '@core/tenant/dealer-id.token';

@Injectable({
  providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(
    private _httpClient: HttpClient,
    @Inject(PLATFORM_ID) private _platformId: object,
    @Optional() @Inject(SITE_ORIGIN_TOKEN) private _siteOrigin: string | null,
  ) {}

  /**
   * Carrega o ficheiro de traduções de um idioma.
   *
   * Em SSR uma URL relativa (`./assets/…`) não resolve — o pedido falha e o
   * transloco volta a pedir a cada change-detection, gerando uma TEMPESTADE de
   * pedidos que satura o processo SSR (um só serve todos os dealers) e derruba
   * o site. Por isso:
   *  - em SSR usa-se URL absoluta (a partir do SITE_ORIGIN) para o ficheiro
   *    resolver de facto;
   *  - `catchError` garante que uma falha nunca propaga nem faz retry-loop
   *    (devolve vazio; o browser recarrega as traduções na hidratação).
   * Sem `?_=Date.now()`: o cache-buster criava uma URL única por pedido e
   * impedia qualquer cache.
   */
  getTranslation(lang: string): Observable<Translation> {
    const base =
      isPlatformServer(this._platformId) && this._siteOrigin
        ? this._siteOrigin
        : '.';
    return this._httpClient
      .get<Translation>(`${base}/assets/i18n/${lang}.json`)
      .pipe(catchError(() => of({})));
  }
}
